<div class="mt-3 mb-3 d-flex flex-column">
  <span class="sub-title">{{ subTitle }}</span>
  <span class="balance">{{ balance | currency }}</span>
</div>
